import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from "react-redux";

import './index.css';
import App from './App';
import configureStore from "./store/configureStore";
import reportWebVitals from './reportWebVitals';

const storeConfiguration = configureStore();

ReactDOM.render(
  <Provider store={storeConfiguration.store}>
    <PersistGate loading={null} persistor={storeConfiguration.persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
